// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4498":"3312642ebd738697","8472":"312ff8ebd80197b4"}[chunkId] + ".js";
};